<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import { useSettings } from "~/store/settings";
import api from "~/utils/auth/api";
import { IKenticoResponse } from "~/types/kentico/content";
import { parseContent } from "~/utils/kentico/ContentParser";
import CustomContent from "../global/kentico/components/CustomContent.vue";
import Loader from "../ui/Loader.vue";

interface Props {
	path: string | undefined;
}

const props = defineProps<Props>();
const settings = useSettings();

const { data, isLoading } = useQuery<IKenticoResponse>({
	queryKey: ["sports-book-landing", settings.locale, settings.getCountryConfig?.countryIsoTwo, props.path],
	queryFn: () =>
		api({
			type: "content",
			url: `?host=content.betwayafrica.com&route=${props.path}&lang=${settings.locale}`,
		}),
});

const parsedContent = computed(() => parseContent(data.value?.content, { applyBindings: true }));
</script>

<template>
	<div class="container">
		<div class="flex items-center justify-center pt-20" v-if="isLoading">
			<Loader />
		</div>
		<CustomContent v-else-if="data" :content="parsedContent?.content" :styles="parsedContent?.styles" :scripts="parsedContent?.scripts" noHeader />
	</div>
</template>
